import {XauditModel} from '../xaudit.model';

export class ColorSchemeDataModel extends XauditModel {
  BackColor: string;
  ColorSchemeId: string;
  ColorSchemeName: string;
  ForeColor: string;
  ToolType: string;
}
